import { AppThunkAction } from '../../../index'
import api from '../../../../api'
import { executeResponseError } from '../../../../helpers'
import {
	ORG_SETTINGS_ORGANIZATION_DETAIL_TYPES, OrganizationDetails,
	OrgSettingsGetOrganizationDetails,
} from './types'

export const orgSettingGetOrganizationDetails = (
	orgId: string
): AppThunkAction<Promise<void>, OrgSettingsGetOrganizationDetails> => {
	return async dispatch => {
		try {
			const res = await api.clinic.getOrganizationDetails(orgId)

			dispatch({
				type: ORG_SETTINGS_ORGANIZATION_DETAIL_TYPES.GET,
				payload: res?.data?.result as unknown as OrganizationDetails || {},
			})
		} catch (e: any) {
			const error = executeResponseError(e, 'Get organization details error')
			throw new Error(error || '')
		}
	}
}

export const orgSettingUpdateOrganizationDetails = (
	data: OrganizationDetails
): AppThunkAction<Promise<void>, OrgSettingsGetOrganizationDetails> => {
	return async dispatch => {
		try {
			await api.clinic.updateOrganizationDetails(data)

			if (data._id) {
				dispatch(orgSettingGetOrganizationDetails(data._id))
			}
		} catch (e: any) {
			const error = executeResponseError(e, 'Save organisation error')
			throw new Error(error || '')
		}
	}
}
